module.exports = __webpack_public_path__ + "static/media/linux-logo.a3f8b36d.png";